module.exports = {
	agree: '注册即代表您同意',
	tos: 'Enhancer 服务条款',
	privacy: '隐私政策',
	inviteCodeInvalid: '邀请码格式不正确',
  inviteCode: "邀请码 (可不填)"
}


// WEBPACK FOOTER //
// ./src/pages/register/i18n/locale.zh-cn.js